import { render, staticRenderFns } from "./CommentDrawer.vue?vue&type=template&id=a8b1af4e&scoped=true"
import script from "./CommentDrawer.vue?vue&type=script&lang=js"
export * from "./CommentDrawer.vue?vue&type=script&lang=js"
import style0 from "./CommentDrawer.vue?vue&type=style&index=0&id=a8b1af4e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b1af4e",
  null
  
)

export default component.exports